import React, { useMemo } from 'react';
import { Box, Card, Stack, Typography } from '@mui/material';
import { HomeStats } from '../mockStats';

interface VocabularyCompositionCardProps {
  composition: HomeStats['composition'];
  totalLearned: number;
  totalActive: number;
}

const VocabularyCompositionCard: React.FC<VocabularyCompositionCardProps> = ({
  composition,
  totalLearned,
  totalActive,
}) => {
  const total = useMemo(
    () => composition.levels.reduce((acc, l) => acc + l.count, 0),
    [composition],
  );
  const activePct = total ? Math.round((totalActive / total) * 100) : 0;
  const learnedPct = total ? Math.round((totalLearned / total) * 100) : 0;

  return (
    <Card sx={{ height: '100%' }}>
      <Stack spacing={2}>
        <Box>
          <Typography variant={'h3'}>{'Склад словника'}</Typography>
          <Typography color={'text.secondary'} variant={'body2'}>
            {'Розподіл по рівнях складності.'}
          </Typography>
        </Box>

        <Stack
          direction={'row'}
          alignItems={'flex-end'}
          spacing={1.5}
          sx={{ height: 120 }}
        >
          {composition.levels.map((l) => {
            const max = Math.max(...composition.levels.map((x) => x.count));
            const height = (l.count / max) * 100;
            return (
              <Box
                key={l.label}
                sx={{
                  alignItems: 'center',
                  display: 'flex',
                  flex: 1,
                  flexDirection: 'column',
                }}
              >
                <Typography
                  variant={'caption'}
                  color={'text.secondary'}
                  sx={{ mb: 0.5 }}
                >
                  {l.count}
                </Typography>
                <Box
                  sx={{
                    bgcolor: l.color,
                    borderRadius: '6px 6px 2px 2px',
                    height: `${height}%`,
                    minHeight: 8,
                    transition: 'height 200ms ease',
                    width: '100%',
                  }}
                />
                <Typography variant={'caption'} sx={{ mt: 0.5, fontWeight: 700 }}>
                  {l.label}
                </Typography>
              </Box>
            );
          })}
        </Stack>

        <Stack direction={'row'} spacing={3}>
          <Box>
            <Typography variant={'caption'} color={'text.secondary'}>
              {'Усього'}
            </Typography>
            <Typography variant={'h5'}>{total}</Typography>
          </Box>
          <Box>
            <Typography variant={'caption'} color={'text.secondary'}>
              {'Вивчено'}
            </Typography>
            <Typography variant={'h5'} sx={{ color: 'primary.aqua' }}>
              {`${totalLearned} (${learnedPct}%)`}
            </Typography>
          </Box>
          <Box>
            <Typography variant={'caption'} color={'text.secondary'}>
              {'Активний'}
            </Typography>
            <Typography variant={'h5'} sx={{ color: 'primary.main' }}>
              {`${totalActive} (${activePct}%)`}
            </Typography>
          </Box>
        </Stack>
      </Stack>
    </Card>
  );
};

export default VocabularyCompositionCard;
